import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import { dataSet, donationDataSet } from './dataSet';
import { familyInfoDataFn } from 'src/fetch/stepA';
import _ from 'lodash';
import { error } from 'console';
const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

// SELECT(LIST) 기부금
export const donationInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any,
  familyInfoDataState?: any,
  familyData?: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/donationfee/lst';
  const fetchKey = 'DONATION_INFO';
  if (!familyData) {
    familyData = await familyInfoDataFn(errorModalState, param, familyInfoDataState, queryClient);
  }
  const familyDataSet = _.cloneDeep(familyData);
  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    const infoData: any = data;
    const { resError, resData } = donationDataSet(infoData, familyDataSet, null);
    console.log('[DONATION_INFO]:', paramSet, data, resData);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// INSERT 기부금
export const fetchInsertDonationData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/donationfee/ist';
  const fetchKey = 'DONATION_INSERT';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// UPDATE 기부금
export const fetchUpdateDonationData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/donationfee/upd';
  const fetchKey = 'DONATION_UPDATE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// DELETE 기부금
export const fetchDeleteDonationData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/donationfee/del';
  const fetchKey = 'DONATION_DELETE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
